import type { CollapseProps } from "antd";

import Info from "./Info";
import CDNFileDetail from "./CDNFileDetails";

export const EditCDNFileConstants = {
	INFO: "Genel Bilgiler",
	CDN_FILE_DETAIL: "CDN Dosyası Detayları"
};

export const CDNFileItems: CollapseProps["items"] = [
	{
		key: "1",
		label: EditCDNFileConstants.INFO,
		children: <Info />,
	},	
	{
		key: "2",
		label: EditCDNFileConstants.CDN_FILE_DETAIL,
		children: <CDNFileDetail />,
	},
];
